import React, { useId } from 'react';
import { INTERFACE_VERSIONS, useInterface } from '../context/InterfaceProvider';
import styles from './InterfaceVersionSelector.module.css';

export default function InterfaceVersionSelector() {
  const id = useId();
  const { version, selectVersion } = useInterface();

  return (
    <div className={styles.selector}>
      <label htmlFor={id}>Interface</label>
      <select id={id} value={version} onChange={(event) => selectVersion(event.target.value)}>
        {INTERFACE_VERSIONS.map(({ value, label }) => (
          <option key={value} value={value}>{label}</option>
        ))}
      </select>
    </div>
  );
}
